export const UNAUTHORIZED_MESSAGE = 'Not authorized';
export const UNEXPECTED_ERROR_TRY_LATER = 'unexpected_error_try_later';

export const UNAUTHORIZED_HTTP_CODE = 401;

export const INTERNAL_SERVER_ERROR_HTTP_CODE = 500;

export const INVALID_MATCH = 'TOURNAMENT_MATCH_INVALID';

export const INVALID_TOURNAMENT = 'TOURNAMENT_INVALID';

export const TOURNAMENT_NOT_FOUND = 'TOURNAMENT_NOT_FOUND';

export const TOURNAMENT_MATCH_NOT_FOUND = 'TOURNAMENT_MATCH_NOT_FOUND';

export const BET_TECHNICAL_ERROR = 'BET_TECHNICAL_ERROR_WILL_BE_RETURNED';

export const FAILED_TO_FETCH_ERROR = 'Failed to fetch';
